<template>
  <div>
    <div class="Message above1200">
        <b-container class="nocon">
                    <b-row >
                        <b-col lg="6" md="6" sm="12">
                            <h2 class="heading">About Clutch</h2>
                            <p class="description" v-html="acfMessage"></p>
                        </b-col>
                    </b-row>
        </b-container>
    </div>
    <div class="MessageMob below1200">
      <b-container class="nocon">
                <b-row >
                    <b-col lg="12" md="12" sm="12">
                        <h2 class="heading">About Clutch</h2>
                        <p class="description" v-html="acfMessage"></p>
                    </b-col>
                    <b-col lg="12" md="12" sm="12">
                        <img class="mobImage" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Image-1.png">
                    </b-col>
                </b-row>
      </b-container>
  </div>
  </div>

</template>

<script>
import axios from 'axios'
export default {
  name: 'Message',
  components: {

  },
  data: function() {
    return {
      acf: [],
      acfMessage:''
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.acfMessage = response.data.acf.message_description
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.mobImage {
    width: 100%;
}
.below768.belowSec {
    margin-top: 35px;
}
.noPadMob.col-sm-2 {
    width: 25%;
}
.noPadMob.col-sm-10 {
    width: 75%;
}
.signature {
    width: 200px;
}
.itemRow {
    margin-bottom: 80px;
}
.itemsTitle {
    color: #081C3F;
    font-size: 40px;
}
.Leftimage {
    width: 87px;
    height: 87px;
}
.Allbuttons {
    width: 420px;
    height: 50px;
    background: transparent;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #081C3F;
    font-size: 16px;
    position: absolute;
    bottom: 0;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    border-radius: 26px;
}
.Allbuttons:hover {
    width: 420px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    position: absolute;
    bottom: 0;
    transform: translateY(-10px);
    border-radius: 26px;
}
.arrow {
    width: 14px;
    height: 12px;
}
.noPad {
    /* padding: 0; */
}
.MessageMob {
    background-color: #fff;
    padding: 3%;
    padding-bottom: 25px;
    padding-top: 0px;
}
.Message {
    background-color: #fff;
    padding: 3%;
    padding-bottom: 90px;
    padding-top: 90px;
    background-image: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Group-325.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
}
.heading {
    font-weight: 600;
    font-size: 36px;
    color: #081C3F;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
/* mobile code */
.containterInside.container.mobContainer {
    padding-top: 40px;
    padding-bottom: 40px;
}
/* End of mobile code */
.description {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #081C3F;
    font-size: 20px;
}
.space {
    margin-top: 30px;
}
.bkImageFull {
    background-color: #000000; /* For browsers that do not support gradients */
}
.containterInside {
    padding-top: 100px;
    padding-bottom: 100px;
}
h2.MainTitle {
    font-size: 28px;
    color: #9CD58A;
    font-weight: bold;
    text-align: left;
}
.image {
    width: 100%;
}
.itemsLeft {
    text-align: left;
    color: #081C3F;
    font-size: 20px;
    /* display: flex; */
    margin-bottom: 20px;
}
.SubTitle {
    color: #9CD58A;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
}
.belowSec {
    padding-top: marpx;
}
@media only screen and (min-width: 1200px) {
    .below1200 {
        display: none;
    }
}
@media only screen and (max-width: 1199px) {
    .above1200 {
        display: none;
    }
}
@media only screen and (min-width: 769px) {
    .below768 {
        display: none;
    }
    .description {
        text-align: left;
        margin-top: 30px;
        margin-bottom: 30px;
        color: #081C3F;
        font-size: 20px;
        padding-right: 100px;
    }
}
@media only screen and (max-width: 990px) {
    .nocon {
        padding-left: 0px;
        padding-right: 0px;
    }
    .heading {
        font-weight: 600;
        font-size: 26px;
        color: #081C3F;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
}
@media only screen and (max-width: 768px) {
    .above768 {
        display: none;
    }
    .itemRow {
        margin-bottom: 20px;
        margin-top: 30px;
    }
    .noPad.col-lg-3 {
        text-align: center;
    }
    .itemsTitle{
        color: #081C3F;
        font-size: 25px;
        text-align: left;
    }
    .itemsLeft {
        text-align: left;
        color: #081C3F;
        font-size: 18px;
        /* display: flex; */
        margin-bottom: 20px;
    }
    .Leftimage {
        width: 60px;
        height: 60px;
    }
    .Message {
        background-color: #fff;
        padding: 3%;
        padding-bottom: 25px;
        padding-top: 25px;
    }
}
</style>
